export default __webpack_public_path__ + "147c84d2dd8c03e8e7552a71c352869e.pdf";